import { render, staticRenderFns } from "./PrizesTable.vue?vue&type=template&id=dfc943a6"
import script from "./PrizesTable.vue?vue&type=script&lang=js"
export * from "./PrizesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports